import {PriceRobotCustomFields} from "./price-robot-custom-fields";
import {Product, ProductInterface} from "@hassel-it/shop-services";
import {Package, PackageInterface} from "./package";
import dayjs, {Dayjs} from "dayjs";

export class CrawlerLog {

    id: number;
    crawler_url_id: number;
    created?: Dayjs;
    modified?: Dayjs;
    process_result?: any;
    static _JSONProps: string[] = [
        'id',
        'crawler_url_id',
        'process_result',
    ];

    constructor(initializer?: CrawlerLogInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: CrawlerLogInterface | string): CrawlerLog {
        if (json === null) {
            return new CrawlerLog();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, CrawlerLog.reviver);
        } else {
            let task = new CrawlerLog();
            let extra = {
                modified: dayjs(json.modified),
                created: dayjs(json.created),
            };

            Object.keys(json).forEach((key, index) => {
                if (CrawlerLog._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? CrawlerLog.fromJSON(value) : value;
    }

}

export interface CrawlerLogInterface extends CrawlerLog {
}
